const InputView = require('../views/inputview');

const formFields = [
  {
    modelKey: 'password',
    label: 'Password*',
    template: 'textViewTpl',
    readonly: "",
    required: "required",
    valRequired: "Password is required.",
    view: InputView,
    id: 'password'
  },
  {
    modelKey: 'confirmPassword',
    label: 'Confirm Password*',
    template: 'textViewTpl',
    readonly: "",
    required: "required",
    valRequired: "Please confirm your password.",
    view: InputView,
    id: 'confirmPassword'
  },
  {
    modelKey: 'save',
    template: 'submitTpl',
    view: InputView
  }
]

export default formFields;
